// 移植自姊妹專案 pixi_slot（FaFaCat 移植案）已驗證的 src/framework/net/urlParams.ts。
// 尚未接上本專案（Slot026）的真實後端，惟本專案與 FaFaCat 共用同一個 Gateway
// （見 CLAUDE.md 對 ServerSetting.asset 的確認），登入流程的網址參數慣例應一致。
//
// 網址參數讀取 — 對應 Unity URLParameter。
// 遊戲 token 與 Demo 模式判定（與後端 BaseGameService 一致）。

function getParam(name: string): string | null {
  if (typeof window === 'undefined') return null
  return new URLSearchParams(window.location.search).get(name)
}

/** 遊戲 token：`?t=` 優先，其次 `?token=`。對應 Unity GetGameToken()。 */
export function getGameToken(): string | null {
  return getParam('t') ?? getParam('token')
}

/**
 * Demo／訪客模式（略過登入）：`?demo=true` 或帶回放參數 `?r`。
 * 對應 Unity `BaseGameService.SendLogin()` 的 isDemo 判定（`BaseGameService.cs:330`）：
 *   `URLParameter.GetURLParameter("demo") == "true" || URLParameter.HasParameter("r")`
 *   （`REPLAY_PARAM_KEY = "r"`，`HasParameter` 只看 key 有無、不看值）。
 * ⚠️ 回放參數是單字母 `r`，不是 `replay`——先前移植誤植為 `replay`，2026-07-29 對齊 Unity 修正。
 */
export function isDemoMode(): boolean {
  return getParam('demo') === 'true' || getParam('r') !== null
}
